import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface FlooringProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Flooring: React.FC<FlooringProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [flooring, set_flooring] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Flooring'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Flooring': v } } })
    );
    const label = 'Flooring';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(flooring)}
                />
            ) : (
                <MoneyBox
                    id={'flooring'}
                    allowNegative={false}
                    value={flooring}
                    onChange={(value) => set_flooring(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
